import * as Sentry from "@sentry/react";
import { env } from "./lib/env";

Sentry.init({
  dsn: env.sentryDsn,
  environment: env.environment || "development",
  integrations: [Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
